export const STATUS = {
  EVALUATED: 'EVALUATED',
  PENDING: 'PENDING',
  TAKEN: 'TAKEN'
}